import { useVideoConfig } from '../config/VideoAppContext';
export const usePlayableAtLocation = media => {
  const {
    isAbroad
  } = useVideoConfig();
  return !isAbroad || media.playableAbroad;
};